import { Dispatch } from 'redux';
import { AircaftData } from '../../Model/AircraftData';
import { GetAllValidAircraft } from '../../services/DelayListService/DelayListService';

const MAX_RETRIES = 3;
const RETRY_DELAY_MS = 1000;

const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

export const fetchAllValidAircrafts = (token: string) => async (dispatch: Dispatch) => {
  // Dispatch an action to indicate that the fetch request has started.
  dispatch({ type: 'FETCH_ALL_VALID_AIRCRAFT_REQUEST' });

  let attempts = 0;

  while (attempts < MAX_RETRIES) {
    try {
      // Make the API call to fetch all valid aircraft.
      const aircraftList: AircaftData[] = await GetAllValidAircraft(token);

      // Dispatch an action with the fetched aircraft list on success.
      dispatch({ type: 'FETCH_ALL_VALID_AIRCRAFT_SUCCESS', payload: aircraftList });
      return; // Exit the function if the API call is successful
    } catch (error: any) {
      attempts += 1;
      if (attempts >= MAX_RETRIES) {
        // Dispatch an action with the error message on failure after max retries.
        dispatch({ type: 'FETCH_ALL_VALID_AIRCRAFT_FAILURE', payload: error.message });
        return;
      }
      // Wait for the specified delay before retrying
      await delay(RETRY_DELAY_MS);
    }
  }
};